<template>
  <MasterLayout>
    <div class="new-staff">
      <div class="add_new_bank_account_header">
        <p>
          {{
            mode === "create"
              ? $t("text.cDrystock.add")
              : $t("text.cDrystock.edit")
          }}
          {{ $t("text.cDrystock.product.createHeader") }}
        </p>
      </div>
      <div class="cover">
        <div class="personal">
          <div class="row">
            <div class="mt-4 input__group__block col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.cDrystock.product.name") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="text"
                  :placeholder="$t('text.cDrystock.product.name')"
                  class="border-0"
                  v-model="nonWetProduct.name"
                />
              </div>
            </div>
            <div class="mt-4 input__group__block col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.cDrystock.product.desc") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="text"
                  :placeholder="$t('text.cDrystock.product.desc')"
                  class="border-0"
                  v-model="nonWetProduct.description"
                />
              </div>
            </div>
            <div class="mt-4 input__group__block col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.cDrystock.product.cate") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <select v-model="nonWetProduct.productCategoryId">
                  <option value="select category">
                    {{ $t("text.cDrystock.product.selectCate") }}
                  </option>
                  <option
                    v-for="(cat, index) in categories"
                    :key="index"
                    :value="cat.id"
                  >
                    {{ cat.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="mt-4 input__group__block col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.cDrystock.product.qtnUnit") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="number"
                  :placeholder="$t('text.cDrystock.product.qtn')"
                  class="border-0"
                  v-model="nonWetProduct.quantityPerUnit"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="pb-4 mt-4 text-center">
          <button
            :disabled="isButtonDisabled ? true : false"
            class="ep-btn ep-primary"
            @click="
              mode === 'create' ? createProduct($event) : updateProduct($event)
            "
          >
            {{
              mode === "create"
                ? $t("text.cDrystock.categories.add")
                : $t("text.cDrystock.categories.save")
            }}
            product
          </button>
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="35px"
            class="ml-3 loader"
          />
        </div>
      </div>
    </div>
  </MasterLayout>
</template>

<script>
import MasterLayout from "@/views/Company/MasterLayout.vue";
import configObject from "@/config";
import backgroundUrl from "@/assets/img/retain.jpg";
import VueTagsInput from "@johmun/vue-tags-input";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "AddStaff",
  components: {
    MasterLayout,
    VueTagsInput,
    PulseLoader,
  },
  data() {
    return {
      productId: null,
      isButtonDisabled: false,
      showLoader: true,
      nonWetProduct: {
        name: null,
        description: null,
        productCategoryId: "select category",
        isActiveForSale: true,
        isLimited: false,
        quantityPerUnit: null,
      },
      mode: "create",
      categories: [],
      company: null,
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getCategories();
      }
    },
  },

  company() {
    return this.$store.getters.getCompanyDetails;
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });

    document.title = "Create Nonwet Product:: Epump Company";
    if (this.$route.query.productId) {
      this.productId = this.$route.query.productId;
      this.getNonWetProduct();
      this.mode = "edit";
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    createProduct($event) {
      $event.preventDefault();
      if (!this.nonWetProduct.name) {
        this.$toast.open({
          message: this.$t("text.errors.nameIsRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.nonWetProduct.description) {
        this.$toast.open({
          message: this.$t("text.errors.descIsRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (this.nonWetProduct.categoryId === "select category") {
        this.$toast.open({
          message: this.$t("text.errors.pleaseSelectCategory"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.nonWetProduct.quantityPerUnit) {
        this.$toast.open({
          message: this.$t("text.errors.enterQuantityUnit"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      let payload = {
        name: this.nonWetProduct.name,
        description: this.nonWetProduct.description,
        quantityPerUnit: parseInt(this.nonWetProduct.quantityPerUnit),
        isActiveForSale: true,
        isLimited: false,
        productCategoryId: this.nonWetProduct.productCategoryId,
      };

      this.isButtonDisabled = true;
      $(".loader").show();

      this.axios
        .post(
          `${configObject.apiBaseUrl}/NonWetProduct/Product/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }/Create`,
          payload,
          configObject.authConfig()
        )
        .then((res) => {
          // console.log(res.data)
          this.$toast.open({
            message: this.$t("text.errors.productCreatedSuccessfully"),
            type: "success",
            duration: 5000,
          });
          this.$router.push({
            name: "NonWetProducts",
            query: { ...this.$route.query },
          });
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    getCategories() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/NonWetProduct/Category/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }/All`,
          configObject.authConfig()
        )
        .then((response) => {
          this.categories = response.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getNonWetProduct() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/NonWetProduct/Product/${this.productId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.nonWetProduct = response.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    updateProduct($event) {
      $event.preventDefault();
      if (!this.nonWetProduct.name) {
        this.$toast.open({
          message: this.$t("text.errors.nameIsRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.nonWetProduct.description) {
        this.$toast.open({
          message: this.$t("text.errors.descIsRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (this.nonWetProduct.categoryId === "select category") {
        this.$toast.open({
          message: this.$t("text.errors.pleaseSelectCategory"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.nonWetProduct.quantityPerUnit) {
        this.$toast.open({
          message: this.$t("text.errors.enterQuantityUnit"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      let payload = {
        name: this.nonWetProduct.name,
        description: this.nonWetProduct.description,
        quantityPerUnit: parseInt(this.nonWetProduct.quantityPerUnit),
        isActiveForSale:
          this.nonWetProduct.isActiveForSale === "true" ? true : false,
        isLimited: this.nonWetProduct.isLimited === "true" ? true : false,
        productCategoryId: this.nonWetProduct.productCategoryId,
      };

      this.isButtonDisabled = true;
      $(".loader").show();

      this.axios
        .post(
          `${configObject.apiBaseUrl}/NonWetProduct/Product/Edit/${this.productId}`,
          payload,
          configObject.authConfig()
        )
        .then((res) => {
          this.$toast.open({
            message: this.$t("text.errors.productUpdatedSuccessfully"),
            type: "success",
            duration: 5000,
          });
          this.$router.push({
            name: "NonWetProducts",
            query: { ...this.$route.query },
          });
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
  },
};
</script>
